import React from 'react'
import { Link } from 'react-router-dom'
import './GenericError.css'

const GenericErrorUI = ({context, error}) =>
  <div className='com_g_error g_flex_v'>
    <div className='content'>
      {(() => {
        switch (error.fieldName) {
          case 'sessionId':
            return <InvalidSessionUI error={error} />
          default:
            return <span>{error.errorCode} {error.objectCode} {error.message}</span>
        }
      })()}
    </div>
  </div>

const InvalidSessionUI = ({error}) =>
  <React.Fragment>
    <div>{error.message}</div>
    <Link to='/'>Please login again</Link>
  </React.Fragment>

export default GenericErrorUI
